import { useAccountRateFieldApi } from '../api';

export const useAccountRatesTAccRateHg = () => {
  const result = useAccountRateFieldApi({
    field: 'T_ACC.RATE_HG',
  });
  return result;
};
